export function initializeSmoothScrolling() {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const anchorName = link.getAttribute('href')?.slice(1);
      if (!anchorName) return;

      const target = document.querySelector(`[data-anchor="${CSS.escape(anchorName)}"]`);
      if (!target) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      event.preventDefault();
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  });
}
